export default __webpack_public_path__ + "static/media/element_21.bbf6d327.jpg";